import { TextField } from '@hypeit-gmbh/hypeit-ui';
import { Grid, TextInputProps } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { DEFAULT_SPAN, TRANS_KEY, useAddressPrefix } from '../Root';

type ZipProps = {
  span?: number;
} & TextInputProps;

export const Zip: React.FC<ZipProps> = ({ span, ...props }) => {
  const { t } = useTranslation();
  const prefix = useAddressPrefix();

  return (
    <Grid.Col span={span ?? DEFAULT_SPAN}>
      <TextField
        fieldName={`${prefix}.zip`}
        label={t(`${TRANS_KEY}.ZIP_LABEL`)}
        required
        {...props}
      />
    </Grid.Col>
  );
};
